export const DEFAULT_PRIMARY = '#4696CA';
export const DEFAULT_SECONDARY = '#F98E39 ';